import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import { Asset } from "../../../../plugins/gatsby-plugin-atollon"
import StructuredText from "../custom-structured-text-renderer"
import FormComponent from "../../form"

const BookingForm = ({ title, image, richContent, form, formTitle, leadFormId }) => {

  return (
    <section className="booking-form" id="book-event">
      <div className="booking-form__inner" data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
        <div className='booking-form__wrapper'>
          <div className="booking-form__content" >
            {title && <h2>{parse(title)}</h2>}
            {richContent && <div className='content'><StructuredText data={richContent} /></div>}
            {image && <Asset asset={image} />}
          </div>

          <div className="booking-form__form">
            <h3>Your Details</h3>
            {form && <FormComponent form={form} title={formTitle} leadFormId={leadFormId} />}
          </div>
        </div>
      </div>
    </section>
  )
}

export default BookingForm

export const query = graphql`
fragment BookingFormProps on DatoCmsBookingForm {
  ... on DatoCmsBookingForm {
    title
    richContent {
      value
    }
    image {
      ...InternalAssetProps
    }
    form {
      ...FormProps
    }
  }
}
`